import { createClient } from '@supabase/supabase-js';
import type { CanonicalTier } from '../types/tiers';

// ============================================
// SUPABASE CONFIGURATION
// Get these values from your Supabase project:
// https://app.supabase.com → Your Project → Settings → API
// ============================================
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not configured. Authentication will not work.');
}

/**
 * Implicit flow is required for email confirmation links:
 * the user often opens the email on a different device/browser than signup,
 * so PKCE code_verifier would not be available.
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    flowType: 'implicit',
  },
});

/**
 * Personal subscription row (readable by owning user).
 * Privileged fields are written only by service-role Cloud Functions.
 */
export interface UserSubscription {
  id: string;
  user_id: string;
  tier: CanonicalTier | string;
  status?: string;
  expires_at: string | null;
  cancel_at_period_end?: boolean;
  stripe_customer_id?: string | null;
  stripe_subscription_id?: string | null;
  stripe_price_id?: string | null;
  created_at: string;
  updated_at: string;
}
